import { SVGFC } from '@repo/toolkit/types'

const StarIcon: SVGFC = ({ color, filled, isIconFilled, ...props }) => {
  if (filled || isIconFilled)
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g clipPath="url(#clip0_8710_155195)">
          <path
            d="M19.9583 10.1375C19.8536 9.81349 19.5662 9.58339 19.2262 9.55275L14.6082 9.13342L12.7821 4.85927C12.6474 4.54603 12.3408 4.34326 12.0001 4.34326C11.6594 4.34326 11.3527 4.54603 11.2181 4.86L9.39198 9.13342L4.77321 9.55275C4.43385 9.58412 4.14722 9.81349 4.04187 10.1375C3.93652 10.4615 4.03381 10.8168 4.29053 11.0408L7.78122 14.1022L6.7519 18.6364C6.67658 18.9697 6.80598 19.3143 7.0826 19.5143C7.23128 19.6217 7.40524 19.6764 7.58066 19.6764C7.73191 19.6764 7.88193 19.6356 8.01658 19.5551L12.0001 17.1743L15.9821 19.5551C16.2735 19.7304 16.6408 19.7144 16.9168 19.5143C17.1936 19.3137 17.3229 18.969 17.2475 18.6364L16.2182 14.1022L19.7089 11.0414C19.9656 10.8168 20.0636 10.4621 19.9583 10.1375Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_8710_155195">
            <rect width="16" height="16" fill="white" transform="translate(4 4)" />
          </clipPath>
        </defs>
      </svg>
    )

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_20453_23103)">
        <path
          d="M8 2.30164C8.07434 2.30175 8.14208 2.34523 8.17285 2.41492V2.41589L9.65137 5.87585L9.76855 6.15027L10.0654 6.17761L13.8047 6.51648C13.8611 6.5216 13.9103 6.55183 13.9414 6.59656L13.9658 6.64636H13.9668C13.9844 6.7007 13.9766 6.75884 13.9473 6.80554L13.9111 6.84753H13.9102L11.085 9.32605L10.8613 9.52234L10.9268 9.81238L11.7598 13.4833C11.7722 13.5391 11.7598 13.5959 11.7266 13.6395L11.6865 13.6786C11.6404 13.7119 11.5835 13.722 11.5312 13.7089L11.4814 13.6874L11.4795 13.6864L8.25586 11.7596L8 11.6063L7.74316 11.7596L4.51855 13.6864V13.6874C4.48696 13.7063 4.45368 13.7137 4.42188 13.7137C4.4033 13.7137 4.38466 13.7109 4.36621 13.705L4.31152 13.6776C4.25094 13.6337 4.22218 13.5579 4.23926 13.4823L4.23828 13.4813L5.07227 9.81238L5.1377 9.52234L4.91406 9.32605L2.08789 6.84753L2.08691 6.84656L2.05176 6.80554C2.03249 6.77481 2.02272 6.73873 2.02344 6.70203L2.0332 6.64636C2.05692 6.57409 2.11988 6.52348 2.19531 6.51648L2.19434 6.5155L5.93359 6.17761L6.23047 6.15027L6.34863 5.87585L7.82617 2.41687C7.85675 2.3457 7.92514 2.30164 8 2.30164Z"
          stroke={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_20453_23103">
          <rect
            width="12.9524"
            height="12.9524"
            fill="white"
            transform="translate(1.52344 1.5238)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default StarIcon
